import React, {useState, useEffect} from 'react';
import logo from "../../assets/logo.png"
import './Login.css'; 
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';

const translations = {
  en: {
    loginToAccount: "Log in to your account",
    email: "Email",
    password: "Password",
    invalidCredentials: "Invalid email or password",
    loggingIn: "Logging in...",
    login: "Log in",
    noAccount: "Don't have an account?",
    signUp: "Sign up",
    requiredFields: "Email and password are required",
    authFailed: "Authentication failed!",
    errorOccurred: "An error occurred. Please try again later."
  },
  nl: {
    loginToAccount: "Log in op je account",
    email: "E-mail",
    password: "Wachtwoord",
    invalidCredentials: "Ongeldige e-mail of wachtwoord",
    loggingIn: "Inloggen...",
    login: "Inloggen",
    noAccount: "Nog geen account?",
    signUp: "Registreren",
    requiredFields: "E-mail en wachtwoord zijn verplicht",
    authFailed: "Authenticatie mislukt!",
    errorOccurred: "Er is een fout opgetreden. Probeer het later opnieuw."
  }
};

const Login = ({isDarkMode, email, password, setEmail, setPassword}) => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [lang, setLang] = useState(Cookies.get('isDutch') === 'true' ? 'nl' : 'en');
  const t = translations[lang];

  useEffect(() => {
    const checkLanguage = () => {
      const cookieIsDutch = Cookies.get('isDutch') === 'true';
      const newLang = cookieIsDutch ? 'nl' : 'en';
      if (newLang !== lang) {
        setLang(newLang);
      }
    };
    checkLanguage();
    const interval = setInterval(checkLanguage, 1000);
    return () => clearInterval(interval);
  }, [lang]);

  // Language preference is managed by user toggle in Sidebar
  // Default to English (false) if cookie doesn't exist

  const validateForm = () => {
    if (!email || !password) {
      setError(t.requiredFields);
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_API_URL}/api/auth/login`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          password: password
        }),
      });

      setLoading(false);

      const responseData = await response.json();

      if (response.ok && responseData.successful) {
        Cookies.set('token', responseData.data.token, { expires: 1 });
        Cookies.set('email', email, { expires: 1 });
        Cookies.set('userId', responseData.data.userId, { expires: 1 });
        Cookies.set('accountType', responseData.data.account.accountType, { expires: 1 });
        navigate('/');
      } else {
        const errorMessage = responseData.error?.message || 
                           responseData.detail?.[0]?.msg ||
                           t.authFailed;
        setError(errorMessage);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error:', error);
      setError(t.errorOccurred);
    }
  };

  return (
    <div className={`login-container ${isDarkMode ? 'dark-mode' : ''}`}>
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-group">
        <div className='flex w-full justify-center'>
        <img src={logo} alt="Logo" className="logo-image !w-auto !h-9" /> 
        </div>
        <h1 className='text-3xl font-bold my-6 text-center'>{t.loginToAccount}</h1>
          <label htmlFor="email">{t.email}</label>
          <input type="email" id="email" className="form-input border"
           value={email}
           onChange={(e) => setEmail(e.target.value)}
          required />
        </div>
        <div className="form-group">
          <label htmlFor="password">{t.password}</label>
          <input type="password" id="password" className="form-input border"
           value={password}
           onChange={(e) => setPassword(e.target.value)}
          required />
        </div>
        {error && <p className="mb-4 text-red-500">{t.invalidCredentials}</p>}
        
        <div className='flex justify-end'>
        <button type="submit" disabled={loading} className='login-button py-2 px-4 mr-0 w-full'>
          {loading ? t.loggingIn : t.login}
        </button>
        </div>
        <div className='flex justify-center mt-4'>
          <p className='text-sm text-gray-500'>{t.noAccount} <Link to="/signup" className='text-primary'>{t.signUp}</Link></p>
        </div>
        
      </form>
    </div>
  );
};

export default Login; 